import React, { useState, useEffect, useRef, useContext } from "react";
import "../styles/style.css";
import "./ai-tasks/ai-tasks.css";
import { convertTo12HourFormat, trimWord } from "../util/helperFunctions";
import emptyImage from "../images/empty.jpg";
import env from "react-dotenv";
import MessageComponent from "./message";
import { ChatContext } from "../context/contexts";
import likeReaction from "../images/reactions/like-reaction.png";
import heartReaction from "../images/reactions/heart-reaction.png";
import hahaReaction from "../images/reactions/haha-reaction.png";
import emojiReaction from "../images/emotion.png";
import ReactionsIndicator from "./reusable/reactions-indicator";
import { groupReactions, getTimeAgo } from "../util/helperFunctions";
import ApiService from "../api/apiService";
import UserHoverPreview from "./user-hover-preview";

function MessageReceiver(props) {
  const Chat = useContext(ChatContext);

  const {
    messageDetail,
    userDetails,
    handleImageClick,
    toggleShowChatReply,
    setChatReplyData,
    toggleShowReactionOptions,
    onClickPin,
    setPrivateMessageModalShow,
    setPrivateMesageModalData,
  } = props;
  const {
    id: chat_id,
    conversation_id,
    content,
    createdAt,
    is_deleted,
    message_attachment,
    reply_to_message_detail,
    user,
    thread_replies,
    is_pinned,
    message_reactions,
    message_reads,
  } = messageDetail;

  const [isShowChatOptions, setShowChatOptions] = useState(false);

  const [____isDeleted, ____setIsDeleted] = useState(false);

  const dropdownRef = useRef(null);

  const groupedReaction = groupReactions(message_reactions);

  const [onlineUserData, setOnlineUserData] = useState(null);
  const [showSeenModal, setShowSeenModal] = useState(false);

  const messageContainerRef = useRef(null);

  const messagesReadsUserNames = message_reads
    ?.filter((messageRead) => messageRead?.user?.display_name)
    .filter((messageRead, index, self) => {
      const userId = messageRead.user.id;
      return index === self.findIndex((msg) => msg.user.id === userId);
    })
    .map((messageRead) =>
      messageRead.user.id === userDetails.id
        ? "You"
        : messageRead.user.display_name,
    );

  useEffect(() => {
    const onlineUsers = Chat.onlineUsers;

    const onlineData = onlineUsers.find(
      (onlineUser) => onlineUser.user_id === user.id,
    );
    setOnlineUserData(onlineData);
  }, [Chat.onlineUsers]);

  const handleOnClickReply = () => {
    const replyData = {
      chat_id,
      conversation_id,
      display_name: user.display_name,
      message: content,
    };

    setShowChatOptions(false);
    setChatReplyData(replyData);
  };

  const handleOnClickPin = (e) => {
    setShowChatOptions(false);
    onClickPin(conversation_id, chat_id);
  };

  const handleOnThreadreply = (e) => {
    setShowChatOptions(false);
    Chat.handleThreadViewMsgId(chat_id);
  };

  const handleViewReactions = (e) => {
    e.preventDefault();
    Chat.handleReactionsViewVisible(message_reactions);
    setShowChatOptions(false);
  };

  const toggleShowChatOptions = (e) => {
    setShowChatOptions((prevState) => !prevState);
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setShowChatOptions(false);
      }
    };

    document.addEventListener("click", handleClickOutside);

    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
  }, []);

  const [isShowingUserPreview, setShowingUserPreview] = useState(false);

  const toggleUserPreview = () => {
    setShowingUserPreview((prev) => !prev);
  };

  const hideUserPreview = () => {
    setShowingUserPreview(false);
  };

  const isTouchDevice = () => {
    return (
      "ontouchstart" in window ||
      navigator.maxTouchPoints > 0 ||
      navigator.msMaxTouchPoints > 0
    );
  };

  const hasAttachment = message_attachment.length > 0;

  const imageAttachments = hasAttachment
    ? message_attachment.filter((attachment) =>
        attachment?.file_type?.includes("image"),
      )
    : [];

  const nonImageAttachments = hasAttachment
    ? message_attachment.filter(
        (attachment) => !attachment?.file_type?.includes("image"),
      )
    : [];

  const FINAL_RESOURCES_URL = process.env.REACT_APP_CHAT_RESOURCES_URL;

  const userDisplayName = userDetails.display_name;
  const isReplyingToOwn =
    reply_to_message_detail?.user?.display_name === userDisplayName;
  const isReplyingToThemselves =
    reply_to_message_detail?.user?.display_name === user?.display_name;

  const profileImage =
    user.profile_photo === "" || user.profile_photo === null
      ? emptyImage
      : `${process.env.REACT_APP_IMAGES_DATA_RESOURCES_URL}/${user.profile_photo}`;

  const userOnline = onlineUserData ? onlineUserData?.is_online : false;
  const lastLogin = userOnline
    ? ""
    : onlineUserData?.last_online
    ? getTimeAgo(onlineUserData?.last_online)
    : null;
  const MAX_VISIBLE_SEEN_USERS = 3;

  const visibleUsers = messagesReadsUserNames.slice(0, MAX_VISIBLE_SEEN_USERS);

  const hiddenCount = messagesReadsUserNames.length - MAX_VISIBLE_SEEN_USERS;
  return (
    <div>
      <div
        className={`message__item-container message__item-container--receiver ${isShowChatOptions ? "message__item-container--menu-open" : ""}`}
        ref={messageContainerRef}
      >
        <div className="message__item-container-2">
          {isShowingUserPreview && (
            <UserHoverPreview
              userPhoto={profileImage}
              userDisplayName={user?.display_name}
              ownUserDisplayName={userDisplayName}
              email_address={user?.email_address}
              userID={user.id}
              ownUserID={userDetails.id}
              onMouseEnter={
                !isTouchDevice() ? () => setShowingUserPreview(true) : null
              }
              onMouseLeave={!isTouchDevice() ? hideUserPreview : null}
              onClick={isTouchDevice() ? toggleUserPreview : null}
              setPrivateMessageModalShow={setPrivateMessageModalShow}
              setPrivateMesageModalData={setPrivateMesageModalData}
            />
          )}
          <div className="user--container">
            <img
              className="message__item-img"
              src={profileImage}
              alt="Seller image"
              onMouseEnter={() => {
                if (!isTouchDevice()) {
                  setShowingUserPreview(true);
                }
              }}
              onClick={() => {
                if (isTouchDevice()) {
                  toggleUserPreview();
                }
              }}
              onMouseLeave={() => {
                if (!isTouchDevice()) {
                  hideUserPreview();
                }
              }}
            />

            <div
              className={`online-indicator ${
                userOnline ? "online-user" : "offline-user"
              }`}
            >
              <span className="tooltip">{`${
                userOnline
                  ? "Online"
                  : `${
                      lastLogin !== null && lastLogin !== undefined
                        ? lastLogin
                        : "Offline"
                    }`
              }`}</span>
            </div>
          </div>
          <div className="message__item-message">
            {reply_to_message_detail && (
              <div
                className="message__item-container-reply--receiver"
                onClick={() => {
                  const target = document.getElementById(
                    reply_to_message_detail.id,
                  );

                  if (target) {
                    target.scrollIntoView({
                      behavior: "smooth",
                      block: "center",
                    });

                    target.classList.add("message-pop");

                    setTimeout(() => {
                      target.classList.remove("message-pop");
                    }, 5000);
                  }
                }}
                style={{ cursor: "pointer" }}
              >
                <small className="message__item-container-reply--detail">
                  {user?.display_name} replied to{" "}
                  {isReplyingToOwn
                    ? "you"
                    : isReplyingToThemselves
                    ? "themselves"
                    : reply_to_message_detail.user.display_name}
                </small>
                <span className="message__item-container-reply-detail--receiver">
                  {reply_to_message_detail.is_deleted
                    ? "DELETED CHAT"
                    : trimWord(reply_to_message_detail.content, 15)}
                </span>
              </div>
            )}
            <span className="message__item-details">
              {!reply_to_message_detail && (
                <span className="message__item-name">{user?.display_name}</span>
              )}
              {/* <span className='message__item-time'>{convertTo12HourFormat(createdAt)}</span> */}
            </span>

            <div>
              <div
                className="message__item-text-container-receiver"
                id={chat_id}
              >
                {is_pinned && (
                  <div className="message-pin-container-receiver">
                    <div>📌</div>
                  </div>
                )}
                <span
                  className={`message__item-text message__item-text--receiver ${
                    is_deleted ? "message__item-deleted" : ""
                  }`}
                  onMouseEnter={(e) => {
                    if (e.target.nextElementSibling) {
                      e.target.nextElementSibling.style.display = "flex";
                    }
                  }}
                  onMouseLeave={(e) => {
                    if (e.target.nextElementSibling) {
                      e.target.nextElementSibling.style.display = "none";
                    }
                  }}
                >
                  <MessageComponent message={content} is_deleted={is_deleted} />
                  {!is_deleted &&
                    content &&
                    /@@Tiger ZERO AI@@/.test(content) && (
                      <div className="ai-command-sent-badge">
                        <i className="fa fa-bolt" />
                        Command sent to Tiger ZERO AI
                      </div>
                    )}
                  {!is_deleted &&
                    content &&
                    /@@Tiger ZERO AI Command@@/.test(content) && (
                      <div className="ai-command-sent-badge ai-command-sent-badge--exclusive">
                        <i className="fa fa-bolt" />
                        AI Command sent
                      </div>
                    )}
                  {!is_deleted && imageAttachments.length > 0 && (
                    <div className="message__item-attachment-grid">
                      {imageAttachments.map((_messageAttachment, index) => {
                        const attachmentLink = `${FINAL_RESOURCES_URL}/${_messageAttachment.attachment}`;

                        return (
                          <img
                            key={`image-${index}`}
                            src={attachmentLink}
                            alt="Attachment"
                            className="message__item-attachment message__item-attachment--grid"
                            onClick={() =>
                              handleImageClick([
                                { src: attachmentLink, type: "image" },
                              ])
                            }
                            style={{ cursor: "pointer" }}
                          />
                        );
                      })}
                    </div>
                  )}
                  {!is_deleted &&
                    nonImageAttachments.map((_messageAttachment, index) => {
                      const attachmentType = _messageAttachment.file_type;
                      const isFileAttachment =
                        attachmentType && attachmentType.includes("pdf");
                      const isVideoAttachment =
                        attachmentType && attachmentType.includes("video");

                      const attachmentLink = `${FINAL_RESOURCES_URL}/${_messageAttachment.attachment}`;

                      if (isVideoAttachment) {
                        return (
                          <video
                            key={`media-${index}`}
                            controls
                            src={attachmentLink}
                            className="message__item-attachment"
                            style={{ cursor: "pointer" }}
                            // onClick={() =>
                            //   handleImageClick([
                            //     { type: "video", sources: [{ src: attachmentLink, type: "video/mp4" }] },
                            //   ])
                            // }
                          >
                            Your browser does not support the video tag.
                          </video>
                        );
                      }

                      if (isFileAttachment) {
                        return (
                          <a
                            key={`file-${index}`}
                            href={attachmentLink}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="message__item-attachment-file"
                          >
                            Click to view the file
                          </a>
                        );
                      }

                      return (
                        <a
                          key={`file-${index}`}
                          href={attachmentLink}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="message__item-attachment-file"
                        >
                          Click to view the file
                        </a>
                      );
                    })}
                </span>
                <span
                  className={`message__item-text message__item-text--receiver message__item-time`}
                >
                  <p>{convertTo12HourFormat(createdAt)}</p>
                </span>
                {!is_deleted && (
                  <div
                    className="message__item-dropdown reaction-option-emoji-btn"
                    ref={dropdownRef}
                  >
                    <button type="button " onClick={toggleShowChatOptions}>
                      <i className="fa fa-ellipsis-h message__item-ellipsis"></i>
                    </button>
                    <div
                      className={`message__item-dropdown-item message-options-receiver ${
                        isShowChatOptions ? "show" : ""
                      }`}
                    >
                      <button
                        type="button"
                        onClick={(e) => handleOnClickPin(e)}
                      >
                        Pin
                      </button>
                      <button type="button" onClick={handleOnClickReply}>
                        Reply
                      </button>
                      <button
                        type="button"
                        onClick={(e) => handleViewReactions(e)}
                      >
                        Info
                      </button>
                      <button
                        type="button"
                        onClick={(e) => handleOnThreadreply(e)}
                      >
                        Reply in thread
                      </button>
                    </div>
                  </div>
                )}
                <div className="message__item-dropdown">
                  {!is_deleted && (
                    <button
                      type="button"
                      onClick={(e) =>
                        toggleShowReactionOptions(chat_id, groupedReaction)
                      }
                      className="reaction-option-emoji-btn"
                    >
                      <img
                        src={emojiReaction}
                        className="reaction-option-emoji"
                      />
                    </button>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="move-right">
          <div className="view-chat-reactions view-chat-reactions-receiver">
            {Object.keys(groupedReaction).map((reaction, index) => (
              <ReactionsIndicator
                reaction={`${reaction}`}
                reaction_details={groupedReaction[reaction]}
                key={index}
              />
            ))}
          </div>
          {thread_replies.length > 0 && (
            <div className="view-thread-replies-receiver">
              <small
                className="thread-indicator"
                onClick={(e) => Chat.handleThreadViewMsgId(chat_id)}
              >
                {thread_replies.length} Thread Replies
              </small>
            </div>
          )}
          {messagesReadsUserNames?.length > 0 && (
            <div className="seen-members-container">
              <small>
                Seen by {visibleUsers.join(", ")}
                {hiddenCount > 0 && (
                  <>
                    {" "}
                    <button
                      type="button"
                      className="seen-more-btn"
                      onClick={() => setShowSeenModal(true)}
                    >
                      +{hiddenCount} more
                    </button>
                  </>
                )}
              </small>
            </div>
          )}
        </div>
      </div>
      {showSeenModal && (
        <div
          className="seen-modal-overlay"
          onClick={() => setShowSeenModal(false)}
        >
          <div className="seen-modal" onClick={(e) => e.stopPropagation()}>
            <div className="seen-modal-header">
              <h3>Seen By</h3>

              <button type="button" onClick={() => setShowSeenModal(false)}>
                ×
              </button>
            </div>

            <div className="seen-modal-body">
              {messagesReadsUserNames.map((name, index) => (
                <div key={index} className="seen-modal-user">
                  {name}
                </div>
              ))}
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default MessageReceiver;
